import { Contact } from 'src/app/core/models/contact/contact.interface';
import { Organization } from 'src/app/core/models/organization/organization.interface';
import { SalesOrderClientOption } from 'src/app/core/models/sales/sales-order-client-option.interface';

const ORGANIZATION_TYPE_LABEL_KEY = 'COMPONENTS.SALES_ORDERS.CLIENT_TYPE.ORGANIZATION';
const CONTACT_TYPE_LABEL_KEY = 'COMPONENTS.SALES_ORDERS.CLIENT_TYPE.CONTACT';

export function buildOrganizationClientOption(organization: Organization): SalesOrderClientOption {
  return {
    id: `org:${organization.id}`,
    type: 'organization',
    typeLabelKey: ORGANIZATION_TYPE_LABEL_KEY,
    entityId: organization.id,
    title: organization.title,
    subtitle: organization.number ?? '',
    customerNumber: organization.number?.trim() || null,
    responsibleUserName: organization.responsibleUserName ?? null,
  };
}

export function buildContactClientOption(contact: Contact): SalesOrderClientOption {
  return {
    id: `contact:${contact.id}`,
    type: 'contact',
    typeLabelKey: CONTACT_TYPE_LABEL_KEY,
    entityId: contact.id,
    title: contact.fullName,
    subtitle: contact.organizationTitle ?? '',
    customerNumber: contact.number?.trim() || null,
    responsibleUserName: contact.responsibleUserName ?? null,
  };
}

export function clientOptionFilter(option: SalesOrderClientOption, term: string): boolean {
  const normalized = term.trim().toLowerCase();
  if (normalized.length === 0) {
    return true;
  }

  return (
    option.title.toLowerCase().includes(normalized) ||
    option.subtitle.toLowerCase().includes(normalized) ||
    (option.customerNumber?.toLowerCase().includes(normalized) ?? false)
  );
}

export function clientOptionFormatter(option: SalesOrderClientOption | null | undefined): string {
  return option?.title ?? '';
}

export function clientOptionCompare(a: SalesOrderClientOption, b: SalesOrderClientOption): boolean {
  return a.id === b.id;
}
